/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ nowText: NonNullable<unknown>, beforeText: NonNullable<unknown> }} Workout_Highlights_Matched_LiftInputs */

const en_us2_workout_highlights_matched_lift = /** @type {(inputs: Workout_Highlights_Matched_LiftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`estimated max strength ${i?.nowText} (was ${i?.beforeText})`)
};

const pt_br2_workout_highlights_matched_lift = /** @type {(inputs: Workout_Highlights_Matched_LiftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`força máxima estimada ${i?.nowText} (antes ${i?.beforeText})`)
};

const es_419_workout_highlights_matched_lift = /** @type {(inputs: Workout_Highlights_Matched_LiftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`fuerza máxima estimada ${i?.nowText} (antes ${i?.beforeText})`)
};

const pt_pt2_workout_highlights_matched_lift = /** @type {(inputs: Workout_Highlights_Matched_LiftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`força máxima estimada ${i?.nowText} (antes ${i?.beforeText})`)
};

const fr_fr2_workout_highlights_matched_lift = /** @type {(inputs: Workout_Highlights_Matched_LiftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`force maximale estimée ${i?.nowText} (avant ${i?.beforeText})`)
};

const de_de2_workout_highlights_matched_lift = /** @type {(inputs: Workout_Highlights_Matched_LiftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`geschätzte Maximalkraft ${i?.nowText} (vorher ${i?.beforeText})`)
};

const it_it2_workout_highlights_matched_lift = /** @type {(inputs: Workout_Highlights_Matched_LiftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`forza massima stimata ${i?.nowText} (prima ${i?.beforeText})`)
};

/**
* | output |
* | --- |
* | "estimated max strength {nowText} (was {beforeText})" |
*
* @param {Workout_Highlights_Matched_LiftInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_highlights_matched_lift = /** @type {((inputs: Workout_Highlights_Matched_LiftInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Highlights_Matched_LiftInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_highlights_matched_lift(inputs)
	if (locale === "es-419") return es_419_workout_highlights_matched_lift(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_highlights_matched_lift(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_highlights_matched_lift(inputs)
	if (locale === "de-DE") return de_de2_workout_highlights_matched_lift(inputs)
	if (locale === "it-IT") return it_it2_workout_highlights_matched_lift(inputs)
	return en_us2_workout_highlights_matched_lift(inputs)
});
export { workout_highlights_matched_lift as "workout-highlights.matched_lift" }